export const palette = {
  primary: '#003D4C',
  secondary: '#003D4C',
  background: '#0f172a',
  text: '#02273b',
  hintsText: '#ffffff',
  placeholder: '#7e8f98',
  info: '#4f46e5',
  error: '#be123c',
  warning: '#eab308',
  success: '#16a34a',
};
